import { useEffect } from 'react';
import { App } from 'antd';
import { useNavigate } from 'react-router-dom';

import {
    useBlockUserByIdMutation,
    useReadUserTokenMutation,
    useSendNewPasswordMutation,
    useUnblockUserByIdMutation,
} from '../service/adminUsersApi';
import getEnvConfig from '../../../../../utils/config/env';

export function useAdminUserMutations() {
    const { notification } = App.useApp();
    const navigate = useNavigate();

    const [
        [unblockUserById, unblockUserState],
        [blockUserById, blockUserState],
        [sendNewPassword, sendNewPasswordState],
        [getAccessToken, getAccessTokenState],
    ] = [
        useUnblockUserByIdMutation(),
        useBlockUserByIdMutation(),
        useSendNewPasswordMutation(),
        useReadUserTokenMutation(),
    ];

    useEffect(() => {
        if (blockUserState.isSuccess) {
            notification.success({
                message: blockUserState.data?.message || 'Успешно',
            });
        }
    }, [blockUserState]);

    useEffect(() => {
        if (unblockUserState.isSuccess) {
            notification.success({
                message: unblockUserState.data?.message || 'Успешно',
            });
        }
    }, [unblockUserState]);

    useEffect(() => {
        if (sendNewPasswordState.isSuccess) {
            notification.success({
                message: sendNewPasswordState.data?.message || 'Успешно',
            });
        }
    }, [sendNewPasswordState]);

    useEffect(() => {
        if (getAccessTokenState.isSuccess) {
            const currentToken = localStorage.getItem('accessToken');

            localStorage.setItem('accessTokenBackup', currentToken);
            localStorage.setItem('accessToken', getAccessTokenState.data.token);
            navigate(`${getEnvConfig().PUBLIC_PATH}/communities/chats`);
            window.location.reload();
        }
    }, [getAccessTokenState]);

    const handleViewUser = user => {
        getAccessToken(user.id);
    };

    const handleChangeCommission = user => {
        navigate(`${user.id}/${user.commission}`);
    };

    return {
        unblockUserById,
        unblockUserState,
        blockUserById,
        blockUserState,
        sendNewPassword,
        sendNewPasswordState,
        getAccessToken,
        getAccessTokenState,
        handleViewUser,
        handleChangeCommission,
    };
}
